import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { userRole_candidate, userRole_globalAdmin, userRole_regionalAdmin, userRole_siteAdmin, userRole_proctorLead } from './../../Common/appConstant';
import { AppMessage } from './../../Common/appMessage';
import { AppUrl } from './../../Common/appUrl';
import { AppGlobals } from './../../Common/Services/app.global';
import { ManageChildHeadersService } from './../../Common/Services/manage-child-headers.service';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { DialogConfirmComponentComponent } from './../../Components/dialog-confirm-component/dialog-confirm-component.component';
import { Enum } from './../../utility/enum.enum';
import { DialogExamDetailsComponent } from './../dialog-exam-details/dialog-exam-details.component';
import { Menu } from '../../utility/menu';

@Component({
  selector: 'app-panel-page',
  templateUrl: './panel-page.component.html',
  styleUrls: ['./panel-page.component.css'],
  providers: [ManageChildHeadersService]
})

export class PanelPageComponent implements OnInit {
  subscriptionTxnStatus: Subscription;
  subscriptionMenus: Subscription;
  subscriptionLoader: Subscription;
  subscriptionNotification: Subscription;
  subscriptionReadyforMaster: Subscription;
  subscriptionUserLoggedIn: Subscription;
  loading: boolean;
  leftMenuList: any;
  userMenu: any;
  txnStatus: boolean;
  panelModel: any;
  isCandidate: boolean;
  showNotification: boolean = false;

  landingUrl: string;     //used to handle landing url for admin and admin as candidate when click on logo
  notificationModel: any = {
    count: 0,
    list: []
  }
  isUserLoggedIn: boolean = false;
  isPublicPage: boolean = false;
  userRole: string; //used in html to hide notification icon for site admin
  acType: string;
  acTypeText: string;
  canSwitch: boolean;
  topleftHeader = ['topLeftHeaderConCls']; //conditional class added to enhance locate center button in scheduled exam location page
  Enum: any = Enum;
  constructor(public _router: Router, private _activatedRoute: ActivatedRoute, public _utility: Utility, public _appGlobals: AppGlobals
    , private _sharedService: SharedService, private _manageChildHeadersService: ManageChildHeadersService, public _dialog: MdDialog
    , public _appMessage: AppMessage, private _location: Location) {


    this.subscriptionReadyforMaster = this._utility.getLoaderStatus().subscribe(
      value => {
        let newStatus = value;
        if (newStatus == true) {
          this.setMaster();
        }
      });

    this.subscriptionLoader = this._utility.getLoaderStatus().subscribe(
      value => {
        let loaderCount = value.lCount;
        setTimeout(() => {
          this.loading = loaderCount > 0 ? true : false;
        });
      });

    this.subscriptionNotification = this._utility.getNotificationStatus().subscribe(
      value => {
        this.notificationModel.count = value.nCount;
      });

    this.subscriptionTxnStatus = this._utility.getTxnStatus().subscribe(
      value => {
        this.txnStatus = value;
      });

    _manageChildHeadersService.headerStatusPassed$.subscribe(
      header => {
        this.setChildPageHeader(header);
      }
    )

    this.subscriptionUserLoggedIn = this._utility.getUserLoggedInStatus().subscribe(
      value => {
        this.isUserLoggedIn = value;
      });

  }

  ngOnInit() {
    // // subscribe to router event
    this._utility.clearTxnStatus();
    this.leftMenuList = {};
    this.userMenu = {};
    this.panelModel = {
      userInfo: {},
      currentRoute: null,
      showChildPageHeader: 0
    };

    if (!document.location.toString().endsWith("/PublicLocations")){
      // IF there is already logged In then move to authenticate user component in  case of page load
      if (this._utility.getAccessTokenInLS() && document.location.hash.toLowerCase().indexOf("user/s0001") == -1) {
        this._router.navigate(['/AuthenticateUser']);
      }
    }

    this._sharedService.getVersion().subscribe(initVersion => {
      this.monitorVersion(initVersion);
    });
  }

  // TODO: This hasn't been a problem so far but it's worth noting that this
  // type of recursion opens us up to stack overflow issues.
  monitorVersion(initVersion) {
    setTimeout(() => {
      this._sharedService.getVersion().subscribe(currentVersion => {
        if (currentVersion == initVersion) {
          this.monitorVersion(initVersion);
        } else {
          this._dialog.open(DialogConfirmComponentComponent, {
            data: {
              modelType: "CONFIRMATION",
              msgTitle: "Page Refresh Required",
              msg: "We have released a new version of this application. Please refresh the page to ensure things continue to work correcty. If you are still seeing issues, first try force refreshing the browser. If issues continue, please contact support."
            }
          });
        }
      });
    }, 300000);
  }

  /**
   * to set the master page, we call it when basic things (like baseURL, logoutURL, userInfo, leftMenus etc.) are ready
   * this.acType && this.acType.toUpperCase() == userRole_candidate - condition added to show notificate when site admin switch role to exam scheduler
   * If Site admin has an eligibity then display switch account feature (if isCandidate comes true in user.json)
  */
  private setMaster() {
    let userLoggedInStatus = this._appGlobals.isUserLoggedIn.getValue();
    this._utility.setUserLoggedInStatus(userLoggedInStatus);
    if (userLoggedInStatus != true && !this.isPublicPage) {
      this._router.navigate([this._utility.authenticateUserRoute]);
      return;
    }
    this.panelModel.userInfo = this._appGlobals.userInfo.getValue();
    let userRole = this.panelModel.userInfo.userRole;
    this.userRole = userRole;
    this.isCandidate = this.panelModel.userInfo.isCandidate;
    this.acType = this._appGlobals.acType.getValue();
    if (this.isCandidate == true && this.userRole.toUpperCase() == userRole_siteAdmin) {
      this.canSwitch = true;
      this.acTypeText = this.acType.toUpperCase() == userRole_candidate ? "Site Administrator" : "Exam Scheduler";
    }
    else {
      this.canSwitch = false;
    }
    if ((userRole && userRole.toUpperCase() == userRole_candidate) || (this.acType && this.acType.toUpperCase() == userRole_candidate)) {
      this.isCandidate = true;
    } else {
      this.isCandidate = false;
    }
    // Admin notifications (globalAdmin/regionalAdmin) were only for pending ID approvals — now handled by Mirilla
    // || userRole && userRole.toUpperCase() == userRole_globalAdmin || userRole && userRole.toUpperCase() == userRole_regionalAdmin
    if (userRole && userRole.toUpperCase() == userRole_candidate
      || this.acType && this.acType.toUpperCase() == userRole_candidate) {
      this.getNotifications();
      this.checkForNotifications(this.panelModel.userInfo.userId);
      this.showNotification = true;
    }
    else {
      this.showNotification = false;
    }
    let leftMenus = this._appGlobals.leftMenusList_CUser.getValue();
    if (leftMenus != null) {
      this.leftMenuList = leftMenus;
    }
    this.landingUrl = this.leftMenuList.landingUrl;//set landing url for admin
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscriptionLoader.unsubscribe();
    this.subscriptionMenus.unsubscribe();
    this.subscriptionNotification.unsubscribe();
    this.subscriptionReadyforMaster.unsubscribe();
    this.subscriptionTxnStatus.unsubscribe();
  }

  // redirect to LocateCenter page
  clickOnLocateCenter() {
    this._router.navigate(['/ScheduleExamLocation']);
  }

  // to set child page header
  setChildPageHeader(headerStatus) {
    this.panelModel.showChildPageHeader = headerStatus;
  }

  private getNotifications() {
    this._sharedService.getNotifications()
      .subscribe(
        (response: any) => {
          this._utility.onSuccessCallback(response, null, () => {
            if (response.response) {
              let page = response.response.paginationInfo;
              page.totalRecords ? this._utility.setNotificationCount(Number(page.totalRecords)) : '';
            }
            if (response.response && response.response.results) {
              this.notificationModel.list = response.response.results;
            }
          }, false);
        }
        , error => this._utility.onErrorCallback(error, null, false));
  }

  updateNotificationStatus(notificationID: number) {
    let param = { "id": notificationID };
    this._sharedService.updateNotificationStatus(param)
      .subscribe(
        response => {
          this._utility.onSuccessCallback(response, null, () => {
            // read status of notification has been changed so change the bold status of message
            if (this.notificationModel.count > 0) {
              this._utility.removeNotificationCount();
            }
            // update 'isRead' status of selected record to 'true'
            this._utility.updateByAttr(this.notificationModel.list, "id", notificationID, "isRead", true);

          }, false);
        },
        error => this._utility.onErrorCallback(error, null, false));
  }

  updateList(cList: any, propName: any, propVal: any, updatePropName: any, updatePropVal: any) {
    if (cList && cList.length > 0 && propName && propName != null && propVal && propVal != null) {
      let selObj =
        cList.find(function (obj) {
          return obj.propName === propVal;
        });
    }
  }

  checkForNotifications(userId: number) {
    const EventSource: any = window['EventSource'];
    let baseURL: string;
    this._appGlobals.baseURL.subscribe(value => baseURL = value);
    const es = new EventSource(baseURL + AppUrl.checkNotification + userId,
      { headers: { 'Content-Type': 'text/event-stream' } });

    es.onconnect = (e) => {
    }
    es.onmessage = evt => {
      if (evt.data) {
        if (evt.data == "1" || evt.data == "-1") {
          if (evt.data == "1") {
            this._utility.addNotificationCount();
          }
          else {
            this._utility.removeNotificationCount();
          }
        }
        else {
          this._utility.addNotificationCount();
          this.notificationModel.list.unshift(JSON.parse(evt.data));
        }
      }
      es.onclose = (e) => {
      }
    }
  }

  // to open the Exam Details dialogbox @click on notification
  openNotificationDetails(notification: any): void {
    if (notification && notification.id) {
      if (notification.isRead && notification.isRead == true) {
        return;
      }
      let notificationID = Number(notification.id);
      this.updateNotificationStatus(notificationID);
      let params = "?examStatus=" + 'ALL';
      params += "&eligibilityCode=" + notification.eligibilityCode;
      params += "&useLocationTimeZone=true";

      this._utility.addLoaderCount();
      this._sharedService.getEligibilities(params)
        .subscribe(
          (data: any) => {
            this._utility.onSuccessCallback(data, null, () => {
              if (data && data.response && data.response.results) {
                let locListTemp = data.response.results;
                if (locListTemp && locListTemp.length > 0) {
                  let dashboardModel = {
                    selectedExamFilterType: null,
                    userInfo: {},
                    examsList: [],
                    showCalendar: false,
                    examsListFDate: new Date(new Date().getFullYear(), 0, 1),
                    examsListTDate: new Date(),
                    selectedExamsListType: null,
                    selectedExamModel: locListTemp[0],
                    idStatusShow: false,
                    countryList: [],
                    selectedCountry: {}
                  };
                  this.openExamDetailsDialog(dashboardModel);
                }
              }
            });
          },
          error => {
            this._utility.onErrorCallback(error);
          },
          () => {
          }
        );
    }
  }

  // to open Exam details _dialog
  private openExamDetailsDialog(dashboardModel: any) {
    let dialogRef = this._dialog.open(DialogExamDetailsComponent,
      {
        data: dashboardModel,
      });
    dialogRef.afterClosed().subscribe(result => {
      // refresh the exams list if user cancelled an exam
      if (result == 1) {
      }
    });
  }

  toggle_class() {
    if (this._utility.toggle_my_Class.toLowerCase() == "inactive") {
      this._utility.toggle_my_Class = 'active';
    } else {
      this._utility.toggle_my_Class = 'inactive';
    }

  }


  /**
   * Show tooltip on notification hover
   * For admin -- display messsage like 'You have n pending ID approval.'
   * For Candidate -- display message like  'You have n notifications'
   */
  showNotificationTooltip() {
    let msg = "";
    msg = `You have ${this.notificationModel.count} notifications`;
    // Pending ID approval tooltip disabled — ID verification now handled by Mirilla
    // let userRole = this.panelModel.userInfo.userRole;
    // if (userRole == userRole_candidate) {
    //   msg = `You have ${this.notificationModel.count} notifications`;
    // } else {
    //   if (this.notificationModel.count <= 0) {
    //     msg = 'You have no pending ID approval.';
    //   }
    //   else {
    //     msg = `You have ${this.notificationModel.count} pending ID `;
    //     msg += (this.notificationModel.count > 1) ? 'approvals' : 'approval';
    //   }
    // }
    return msg;
  }

  /**
   * Implement log out functionality
   * Display a cofirm box first, If say 'Yes' clear local storage
   */
  logout() {
    let confimrMsg = this._appMessage.getItem['UMsg00074'];
    let confirmDialogMsgModel = {
      modelType: "LOGOUT",
      msgTitle: "Logout",
      msg: confimrMsg,
      isConfirmBox: true,
      confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
      cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
    };
    let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
      {
        data: confirmDialogMsgModel
      });
    confirmDialogMsgRef.afterClosed().subscribe(result => {
      //when selected ok from the confimation box
      if (result == "1") {
        this._sharedService.logoutUser().subscribe(response => {
          this._utility.onSuccessCallback(response, null, () => {
            this._utility.logoutUser();
          })
        }, error => this._utility.onErrorCallback(error));
      }
    })
  }


  //handling header panel of candidate flow in case of login on behalf of candidate
  onActivate() {
    let activeRoute = (this._activatedRoute.snapshot["_routerState"].url).toLowerCase();
    let landingUrl = this._utility.isAdminAsCandidate() ? "/AdmManageEligibilities" : "/Dashboard";

    if (activeRoute!="/publiclocations"){
      if (JSON.stringify(this.leftMenuList) == JSON.stringify(Menu.leftMenusList.publicLocations)){
        this.leftMenuList = this.userMenu;
      }
    }
    else {
      if (JSON.stringify(this.leftMenuList) != JSON.stringify(Menu.leftMenusList.publicLocations)){
        this.userMenu = this.leftMenuList;
      }
      this.leftMenuList = Menu.leftMenusList.publicLocations;
    }

    switch (activeRoute) {
      // note the lower case.
      // Public Page:
      case "/publiclocations":
        this.topleftHeader = ['topLeftHeaderConCls'];
        this._manageChildHeadersService.setHeaderStatus(1); // show both
        this._utility.showGradientBandAtTop = false; // Shadow band effect on Location and Map page only
        this.isPublicPage = true;
        this.showNotification = false;
        break;
      case "/scheduleexamdate":
        this.topleftHeader = ['topLeftHeaderConCls'];
        this._manageChildHeadersService.setHeaderStatus(2); // show both
        this.landingUrl = landingUrl;
        this._utility.showGradientBandAtTop = false; // Shadow band effect on Location and Map page only
        break;
      case "/scheduleexamlocation":
        this._manageChildHeadersService.setHeaderStatus(1); // hide one
        this.topleftHeader.push('locatebuttonEnhancement'); // conditional class added to enhance locate center button in scheduled exam location page
        this.landingUrl = landingUrl;
        this._utility.showGradientBandAtTop = true; // Shadow band effect on Location and Map page only
        break;
      case "/dashboard":
        this._manageChildHeadersService.setHeaderStatus(0); // hide both
        this.landingUrl = landingUrl;
        this._utility.showGradientBandAtTop = false;
        break; // when admin login as candidate change the landing url
      default:
        this._manageChildHeadersService.setHeaderStatus(0); // hide both
        this.landingUrl = this.leftMenuList.landingUrl;
        this._utility.showGradientBandAtTop = false;
    }
  }

  public switchACType() {
    this._appGlobals.userId = this.panelModel.userInfo.userId; // set userId in appGlobal userId variable so that dashboard routes could activate.
    this.isCandidate = this.panelModel.userInfo.isCandidate;//this._appGlobals.isEligibility.getValue();
    if (this.isCandidate == true) {
      this.acType = this._appGlobals.acType.getValue();
      this.acType = this.acType.toUpperCase() == userRole_candidate ? userRole_siteAdmin : userRole_candidate;
      this._appGlobals.acType.next(this.acType);
      this.acTypeText = this.acType.toUpperCase() == userRole_candidate ? "Site Administrator" : "Exam Scheduler";

      // Re-populate menus and redirect to landing page
      let menusListObj = this._utility.leftMenusList[this._utility.convertToCase(this.acType, 'l')];
      this._appGlobals.leftMenusList_CUser.next(menusListObj);
      // call function to set master page
      this._utility.setReadyForMasterStatus(true);

      // navigate user to landing page
      if (menusListObj && menusListObj.landingUrl) {
        this._router.navigate([menusListObj.landingUrl]);
      }
    }
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/panel-page/panel-page.component.ts